var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('basic-shape',{attrs:{"level":0,"customClass":_vm.computedClass,"customStyle":_vm.computedStyle}})}
var staticRenderFns = []

export { render, staticRenderFns }